<template lang="pug">
.crowd-container
  .crowd-list
    .crowd-item(v-for="item in selectedCrowd",
        @click="showCrowd(item)"
      )
      span.fa-icon(
          :style="item.style"
        )
        i.fa.fa-user-circle-o
      span {{item.name}}
      span.close(
          @click.stop="dropCrowd(item)"
        )
        i.fa.fa-times
    .crowd-item.crowd-add(@click="openCrowd",
       v-show="selectedCrowd.length < 5"
      )
      span.fa-icon
        i.fa.fa-user-circle-o
      span 添加人群

</template>
<script>
export default {
  props: {
    selectedCrowd: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    showCrowd (item) {
      this.$emit('showCrowd', item)
    },
    dropCrowd (item) {
      this.$emit('dropCrowd', item)
    },
    openCrowd () {
      this.$emit('openCrowd')
    }
  }
}
</script>
<style scoped>
.crowd-container {
  padding: 0 10px;
}
.crowd-list {
    overflow: hidden;
    margin-bottom: 15px;
}
.crowd-item {
    float: left;
    width: 240px;
    line-height: 50px;
    border: 1px solid #e5e5e5;
    position: relative;
    margin: 5px;
    cursor: pointer;
    .close {
        position: absolute;
        top: -18px;
        right: 2px;
        font-size: 14px;
        color: #abbccc;
    }
}
.crowd-add {
    border: 1px dashed #abbccc;
    color: #7d93b3;
    font-size: 14px;
    cursor: pointer;
}
.fa-icon {
    float: left;
    width: 50px;
    font-size: 20px;
    text-align: center;
    background: #f9fbfd;
    margin-right: 15px;
}

</style>



// WEBPACK FOOTER //
// crowTags.vue?c005c296